"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: account/credit-card-account-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Faccount%2Fcredit-card-account-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditCardAccountServiceClient = exports.UpdateFlexAccountResponse = exports.UpdateFlexAccountRequest = exports.SetAutoPayResponse = exports.SetAutoPayRequest = exports.DisableRolloverResponse = exports.DisableRolloverRequest = exports.EnableRolloverResponse = exports.EnableRolloverRequest = exports.DeactivateResponse = exports.DeactivateRequest = exports.ActivateResponse = exports.ActivateRequest = exports.CreateAccountResponse = exports.CreateAccountRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const amount_1 = require("../common/amount");
const account_1 = require("./account");
const protobufPackage = 'com.step.account.proto';
function createBaseCreateAccountRequest() {
    return { currency: '' };
}
exports.CreateAccountRequest = {
    fromJSON(object) {
        const message = {
            currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.currency !== '') {
            obj.currency = message.currency;
        }
        return obj;
    },
    create(base) {
        return exports.CreateAccountRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateAccountRequest();
        message.currency = object.currency ?? '';
        return message;
    },
};
function createBaseCreateAccountResponse() {
    return { account: account_1.Account.fromPartial({}) };
}
exports.CreateAccountResponse = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account) ? account_1.Account.fromJSON(object.account) : account_1.Account.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = account_1.Account.toJSON(message.account);
        }
        return obj;
    },
    create(base) {
        return exports.CreateAccountResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateAccountResponse();
        message.account = (object.account !== undefined && object.account !== null)
            ? account_1.Account.fromPartial(object.account)
            : account_1.Account.fromPartial({});
        return message;
    },
};
function createBaseActivateRequest() {
    return {};
}
exports.ActivateRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.ActivateRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseActivateRequest();
        return message;
    },
};
function createBaseActivateResponse() {
    return { account: account_1.Account.fromPartial({}) };
}
exports.ActivateResponse = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account) ? account_1.Account.fromJSON(object.account) : account_1.Account.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = account_1.Account.toJSON(message.account);
        }
        return obj;
    },
    create(base) {
        return exports.ActivateResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseActivateResponse();
        message.account = (object.account !== undefined && object.account !== null)
            ? account_1.Account.fromPartial(object.account)
            : account_1.Account.fromPartial({});
        return message;
    },
};
function createBaseDeactivateRequest() {
    return {};
}
exports.DeactivateRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.DeactivateRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseDeactivateRequest();
        return message;
    },
};
function createBaseDeactivateResponse() {
    return { account: account_1.Account.fromPartial({}) };
}
exports.DeactivateResponse = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account) ? account_1.Account.fromJSON(object.account) : account_1.Account.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = account_1.Account.toJSON(message.account);
        }
        return obj;
    },
    create(base) {
        return exports.DeactivateResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDeactivateResponse();
        message.account = (object.account !== undefined && object.account !== null)
            ? account_1.Account.fromPartial(object.account)
            : account_1.Account.fromPartial({});
        return message;
    },
};
function createBaseEnableRolloverRequest() {
    return {};
}
exports.EnableRolloverRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.EnableRolloverRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseEnableRolloverRequest();
        return message;
    },
};
function createBaseEnableRolloverResponse() {
    return { account: account_1.Account.fromPartial({}) };
}
exports.EnableRolloverResponse = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account) ? account_1.Account.fromJSON(object.account) : account_1.Account.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = account_1.Account.toJSON(message.account);
        }
        return obj;
    },
    create(base) {
        return exports.EnableRolloverResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEnableRolloverResponse();
        message.account = (object.account !== undefined && object.account !== null)
            ? account_1.Account.fromPartial(object.account)
            : account_1.Account.fromPartial({});
        return message;
    },
};
function createBaseDisableRolloverRequest() {
    return {};
}
exports.DisableRolloverRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.DisableRolloverRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseDisableRolloverRequest();
        return message;
    },
};
function createBaseDisableRolloverResponse() {
    return { account: account_1.Account.fromPartial({}) };
}
exports.DisableRolloverResponse = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account) ? account_1.Account.fromJSON(object.account) : account_1.Account.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = account_1.Account.toJSON(message.account);
        }
        return obj;
    },
    create(base) {
        return exports.DisableRolloverResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDisableRolloverResponse();
        message.account = (object.account !== undefined && object.account !== null)
            ? account_1.Account.fromPartial(object.account)
            : account_1.Account.fromPartial({});
        return message;
    },
};
function createBaseSetAutoPayRequest() {
    return { autoPay: account_1.UnsecuredCreditAutoPay.fromPartial({}) };
}
exports.SetAutoPayRequest = {
    fromJSON(object) {
        const message = {
            autoPay: isSet(object.autoPay)
                ? account_1.UnsecuredCreditAutoPay.fromJSON(object.autoPay)
                : account_1.UnsecuredCreditAutoPay.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.autoPay !== undefined) {
            obj.autoPay = account_1.UnsecuredCreditAutoPay.toJSON(message.autoPay);
        }
        return obj;
    },
    create(base) {
        return exports.SetAutoPayRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetAutoPayRequest();
        message.autoPay = (object.autoPay !== undefined && object.autoPay !== null)
            ? account_1.UnsecuredCreditAutoPay.fromPartial(object.autoPay)
            : account_1.UnsecuredCreditAutoPay.fromPartial({});
        return message;
    },
};
function createBaseSetAutoPayResponse() {
    return { account: account_1.Account.fromPartial({}) };
}
exports.SetAutoPayResponse = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account) ? account_1.Account.fromJSON(object.account) : account_1.Account.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = account_1.Account.toJSON(message.account);
        }
        return obj;
    },
    create(base) {
        return exports.SetAutoPayResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetAutoPayResponse();
        message.account = (object.account !== undefined && object.account !== null)
            ? account_1.Account.fromPartial(object.account)
            : account_1.Account.fromPartial({});
        return message;
    },
};
function createBaseUpdateFlexAccountRequest() {
    return { creditFirst: undefined, selectedCreditLimit: undefined, autoPay: undefined };
}
exports.UpdateFlexAccountRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.creditFirst)) {
            message.creditFirst = globalThis.Boolean(object.creditFirst);
        }
        if (isSet(object.selectedCreditLimit)) {
            message.selectedCreditLimit = amount_1.Amount.fromJSON(object.selectedCreditLimit);
        }
        if (isSet(object.autoPay)) {
            message.autoPay = account_1.UnsecuredCreditAutoPay.fromJSON(object.autoPay);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.creditFirst !== undefined) {
            obj.creditFirst = message.creditFirst;
        }
        if (message.selectedCreditLimit !== undefined) {
            obj.selectedCreditLimit = amount_1.Amount.toJSON(message.selectedCreditLimit);
        }
        if (message.autoPay !== undefined) {
            obj.autoPay = account_1.UnsecuredCreditAutoPay.toJSON(message.autoPay);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateFlexAccountRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateFlexAccountRequest();
        message.creditFirst = object.creditFirst ?? undefined;
        message.selectedCreditLimit =
            (object.selectedCreditLimit !== undefined && object.selectedCreditLimit !== null)
                ? amount_1.Amount.fromPartial(object.selectedCreditLimit)
                : undefined;
        message.autoPay = (object.autoPay !== undefined && object.autoPay !== null)
            ? account_1.UnsecuredCreditAutoPay.fromPartial(object.autoPay)
            : undefined;
        return message;
    },
};
function createBaseUpdateFlexAccountResponse() {
    return { account: account_1.Account.fromPartial({}) };
}
exports.UpdateFlexAccountResponse = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account) ? account_1.Account.fromJSON(object.account) : account_1.Account.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = account_1.Account.toJSON(message.account);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateFlexAccountResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateFlexAccountResponse();
        message.account = (object.account !== undefined && object.account !== null)
            ? account_1.Account.fromPartial(object.account)
            : account_1.Account.fromPartial({});
        return message;
    },
};
/**
 * Credit Card Account Service API.
 */
class CreditCardAccountServiceClient {
    rpc;
    name = 'com.step.account.proto.CreditCardAccountService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/account';
    methods = [{
            name: 'CreateAccount',
            requestType: exports.CreateAccountRequest,
            responseType: exports.CreateAccountResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'Activate',
            requestType: exports.ActivateRequest,
            responseType: exports.ActivateResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'Deactivate',
            requestType: exports.DeactivateRequest,
            responseType: exports.DeactivateResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'EnableRollover',
            requestType: exports.EnableRolloverRequest,
            responseType: exports.EnableRolloverResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'DisableRollover',
            requestType: exports.DisableRolloverRequest,
            responseType: exports.DisableRolloverResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'SetAutoPay',
            requestType: exports.SetAutoPayRequest,
            responseType: exports.SetAutoPayResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'UpdateFlexAccount',
            requestType: exports.UpdateFlexAccountRequest,
            responseType: exports.UpdateFlexAccountResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Create a credit card account.
     */
    createAccount(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Activate a credit card account. It will make all card purchases posted to credit card account.
     */
    activate(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Deactivate a credit card account. It will make all card purchases posted to credit card account.
     */
    deactivate(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Enable rollover. Deprecated, currently no-op, only returns the account.
     */
    enableRollover(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Disable rollover. Deprecated, currently no-op, only returns the account.
     */
    disableRollover(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Change the auto pay settings for the account.
     */
    setAutoPay(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Update flex account.
     */
    updateFlexAccount(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[6],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.CreditCardAccountServiceClient = CreditCardAccountServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=credit-card-account-service.js.map